"use strict";
exports.__esModule = true;
var rxjs_1 = require("rxjs");
var internal_compatibility_1 = require("rxjs/internal-compatibility");
var operators_1 = require("rxjs/operators");
var cookies_1 = require("../utils/cookies");
var API_URL = twGlobal.APIEndpoint;
(0, rxjs_1.fromEvent)(window, "DOMContentLoaded", { once: true }).subscribe(function () {
    var clicks$ = (0, rxjs_1.fromEvent)(document.body, "click").pipe((0, operators_1.filter)(function (e) { return e.type === "click"; }), (0, operators_1.map)(function (e) {
        var _a;
        var $el = e.target;
        return ($el === null || $el === void 0 ? void 0 : $el.hasAttribute("data-score-id")) ? (_a = $el === null || $el === void 0 ? void 0 : $el.dataset) === null || _a === void 0 ? void 0 : _a.scoreId : null;
    }), (0, operators_1.filter)(function (e) { return !!e; }), (0, operators_1.switchMap)(function (id) {
        if ((0, cookies_1.getCookie)("scored_".concat(id))) {
            throw new Error("È stato già espresso un voto");
        }
        var query = new URLSearchParams({ id: id }).toString();
        return (0, internal_compatibility_1.ajaxGetJSON)("".concat(API_URL, "tw/v1/faq-score/?").concat(query));
    }), (0, operators_1.catchError)(function (_) { return (0, rxjs_1.of)({ response: { html: "" } }); }));
    clicks$.subscribe(function (_a) {
        var code = _a.code, response = _a.response;
        if (code === 200 && response.parameters.id) {
            (0, cookies_1.setCookie)("scored_".concat(response.parameters.id), "true");
        }
    });
});
